module.exports = __webpack_public_path__ + "static/media/user-circle-solid.bbaceeb9.svg";